// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_COMPACTING_INWARD_REQUEST = 'FETCH_COMPACTING_INWARD_REQUEST';
export const FETCH_COMPACTING_INWARD_SUCCESS = 'FETCH_COMPACTING_INWARD_SUCCESS';
export const FETCH_COMPACTING_INWARD_FAILURE = 'FETCH_COMPACTING_INWARD_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_COMPACTING_INWARD_REQUEST = 'CREATE_COMPACTING_INWARD_REQUEST';
export const CREATE_COMPACTING_INWARD_SUCCESS = 'CREATE_COMPACTING_INWARD_SUCCESS';
export const CREATE_COMPACTING_INWARD_FAILURE = 'CREATE_COMPACTING_INWARD_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_COMPACTING_INWARD = 'CREATE_USER_FORM_COMPACTING_INWARD';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_COMPACTING_INWARD_REQUEST = 'UPDATE_COMPACTING_INWARD_REQUEST';
export const UPDATE_COMPACTING_INWARD_SUCCESS = 'UPDATE_COMPACTING_INWARD_SUCCESS';
export const UPDATE_COMPACTING_INWARD_FAILURE = 'UPDATE_COMPACTING_INWARD_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_COMPACTING_INWARD_REQUEST = 'FETCH_SINGLE_COMPACTING_INWARD_REQUEST';
export const FETCH_SINGLE_COMPACTING_INWARD_SUCCESS = 'FETCH_SINGLE_COMPACTING_INWARD_SUCCESS';
export const FETCH_SINGLE_COMPACTING_INWARD_FAILURE = 'FETCH_SINGLE_COMPACTING_INWARD_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_COMPACTING_INWARD_REQUEST = 'DELETE_COMPACTING_INWARD_REQUEST';
export const DELETE_COMPACTING_INWARD_SUCCESS = 'DELETE_COMPACTING_INWARD_SUCCESS';
export const DELETE_COMPACTING_INWARD_FAILURE = 'DELETE_COMPACTING_INWARD_FAILURE';

export const FETCH_PENDING_COMPACTING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_COMPACTING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_COMPACTING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_COMPACTING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_COMPACTING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_COMPACTING_PO_IN_INWARD_FAILURE';

// USERFORM RESET

export const COMPACTING_INWARD_USERFORM_RESET = 'COMPACTING_INWARD_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_COMPACTING_INWARD_DETAILS = 'NAVIGATE_COMPACTING_INWARD_DETAILS';
// navigate to company component
export const NAVIGATE_COMPACTING_INWARD = 'NAVIGATE_COMPACTING_INWARD';

export const SET_ACTIVE_KEY_COMPACTING_INWARD = 'SET_ACTIVE_KEY_COMPACTING_INWARD';

export const RESET_FORM_DATA_WITHOUT_COMPACTING_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_COMPACTING_INWARD_ID';

export const SET_UNIT_NAME_COMPACTING_INWARD = 'SET_UNIT_NAME_COMPACTING_INWARD';
export const SET_START_DATE_COMPACTING_INWARD = 'SET_START_DATE_COMPACTING_INWARD';
export const SET_END_DATE_COMPACTING_INWARD = 'SET_END_DATE_COMPACTING_INWARD';
